export default "__VITE_ASSET__BbRImNR7__"